import { render, staticRenderFns } from "./TemperatureIqFreeze.vue?vue&type=template&id=f0d11546&lang=pug"
import script from "./TemperatureIqFreeze.vue?vue&type=script&lang=js"
export * from "./TemperatureIqFreeze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports